<app-auth-layout>
  <app-reset-password-form></app-reset-password-form>
</app-auth-layout>
